import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Footer = ({ darkMode }) => {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  return (
    <footer className={`relative ${darkMode ? 'bg-gradient-to-br from-gray-900 via-gray-800 to-black text-gray-300' : 'bg-gradient-to-br from-gray-50 via-white to-gray-100 text-gray-700'} border-t ${darkMode ? 'border-gray-800' : 'border-gray-200'}`}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        
        {/* Top Section - Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-16">
          
          {/* About Us */}
          <div className="col-span-1">
            <h3 className={`text-xl font-bold mb-6 ${darkMode ? 'text-white' : 'text-gray-900'} relative inline-block`}>
              About Us
            </h3>
            <div className={`space-y-4 text-sm leading-relaxed ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
              <p>
                Doctor World Consultancy is dedicated to guiding Indian students toward successful medical careers abroad. We provide complete support for MBBS admissions, including personalized career counselling, university selection, admission processing, visa assistance, and travel guidance.
              </p>
              <p>
                Our mission is to offer genuine, transparent, and reliable guidance so students can access the best global opportunities in medical education. We believe every aspiring doctor deserves the right direction and support to achieve their dreams.
              </p>
            </div>
          </div>

          {/* Contact Information */}
          <div className="col-span-1">
            <h3 className={`text-xl font-bold mb-6 ${darkMode ? 'text-white' : 'text-gray-900'} relative inline-block`}>
              Contact Information
            </h3>
            <ul className="space-y-5">
              <li className="flex items-start">
                <svg className={`w-5 h-5 mt-1 mr-3 flex-shrink-0 ${darkMode ? 'text-blue-400' : 'text-blue-600'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <div className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'} flex flex-col space-y-1`}>
                  <a href="tel:+916364249519" className="hover:text-blue-500 transition-colors">+91 6364 249 519</a>
                  <a href="tel:+919845298192" className="hover:text-blue-500 transition-colors">+91 98452 98192</a>
                </div>
              </li>
              <li className="flex items-start">
                <svg className={`w-5 h-5 mt-0.5 mr-3 flex-shrink-0 ${darkMode ? 'text-blue-400' : 'text-blue-600'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href="mailto:doctorworldconsultancy@gmail.com" className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'} hover:text-blue-500 transition-colors break-all`}>
                  doctorworldconsultancy@gmail.com
                </a>
              </li>
              <li className="flex items-start">
                <svg className={`w-5 h-5 mt-0.5 mr-3 flex-shrink-0 ${darkMode ? 'text-blue-400' : 'text-blue-600'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                  Kolar, India<br/>
                  <span className="text-xs mt-1 text-gray-500 inline-block">(Operations hub)</span>
                </span>
              </li>
            </ul>
          </div>

        {/* Quick Links */}
          <div className="col-span-1">
            <h3 className={`text-xl font-bold mb-6 ${darkMode ? 'text-white' : 'text-gray-900'} relative inline-block`}>
              Quick Links
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className={`group flex items-center text-sm font-medium ${darkMode ? 'text-gray-400 hover:text-blue-400' : 'text-gray-600 hover:text-blue-600'} transition-colors`}>
                  <svg className={`w-4 h-4 mr-3 ${darkMode ? 'text-blue-500' : 'text-blue-600'} group-hover:scale-110 transition-transform`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/></svg>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/student-form" className={`group flex items-center text-sm font-medium ${darkMode ? 'text-gray-400 hover:text-blue-400' : 'text-gray-600 hover:text-blue-600'} transition-colors`}>
                  <svg className={`w-4 h-4 mr-3 ${darkMode ? 'text-blue-500' : 'text-blue-600'} group-hover:scale-110 transition-transform`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>
                  Apply Now
                </Link>
              </li>
              <li>
                <Link to="/status-check" className={`group flex items-center text-sm font-medium ${darkMode ? 'text-gray-400 hover:text-blue-400' : 'text-gray-600 hover:text-blue-600'} transition-colors`}>
                  <svg className={`w-4 h-4 mr-3 ${darkMode ? 'text-blue-500' : 'text-blue-600'} group-hover:scale-110 transition-transform`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
                  Check Application Status
                </Link>
              </li>
              <li>
                <Link to="/admin-login" className={`group flex items-center text-sm font-medium ${darkMode ? 'text-gray-400 hover:text-blue-400' : 'text-gray-600 hover:text-blue-600'} transition-colors`}>
                  <svg className={`w-4 h-4 mr-3 ${darkMode ? 'text-blue-500' : 'text-blue-600'} group-hover:scale-110 transition-transform`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/></svg>
                  Admin Portal
                </Link>
              </li>
            </ul>
          </div>
          
        </div>

        {/* Divider */}
        <div className={`my-8 border-t ${darkMode ? 'border-gray-800' : 'border-gray-200'}`}></div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center md:items-end space-y-4 md:space-y-0">
          
          <div className="text-center md:text-left space-y-1">
            <p className={`text-[12px] font-medium ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
              © {new Date().getFullYear()} Doctor World Consultancy. All rights reserved.
            </p>
            <p className={`text-[12px] ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
              Legal Entity: Narayanaswamy P V &nbsp;&middot;&nbsp; GSTIN: 29AVVPN8430D1Z2
            </p>
            <p className={`text-[11px] ${darkMode ? 'text-gray-500' : 'text-gray-400'} pt-1`}>
              Empowering dreams, building futures in medical education.
            </p>
          </div>

          <div className="flex flex-col md:items-end items-center space-y-2 pb-2">
            <div className={`flex flex-wrap justify-center items-center gap-x-3 gap-y-2 text-xs font-semibold ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
              <button 
                onClick={() => setShowTerms(true)}
                className={`hover:text-blue-500 cursor-pointer transition-colors ${darkMode ? 'underline decoration-gray-600' : 'underline decoration-gray-300'}`}>
                Terms & Conditions
              </button>
              <span className="text-gray-300 dark:text-gray-600">|</span>
              <button 
                onClick={() => setShowPrivacy(true)}
                className={`hover:text-blue-500 cursor-pointer transition-colors ${darkMode ? 'underline decoration-gray-600' : 'underline decoration-gray-300'}`}>
                Privacy Policy
              </button>
              <span className="text-gray-300 dark:text-gray-600 mx-2 ml-4"></span>
              <a href="https://doctorworldconsultancy.com" className="hover:text-blue-500 transition-colors hidden sm:inline-block">
                www.doctorworldconsultancy.com
              </a>
              <div className="flex items-center text-xs font-medium text-emerald-500 ml-4">
                <span className="relative flex h-2 w-2 mr-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
                </span>
                Online
              </div>
            </div>
          </div>
          
        </div>
      </div>

      {/* Terms & Conditions Modal */}
      {showTerms && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setShowTerms(false)}></div>
          <div className={`relative w-full max-w-2xl rounded-2xl shadow-xl p-6 ${darkMode ? 'bg-gray-800 text-gray-300 border border-gray-700' : 'bg-white text-gray-700'} max-h-[80vh] flex flex-col`}>
            <div className="flex justify-between items-center mb-4">
              <h2 className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>Terms & Conditions</h2>
              <button 
                onClick={() => setShowTerms(false)}
                className={`p-2 rounded-full ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'}`}
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
              </button>
            </div>
            <div className="overflow-y-auto pr-2 space-y-4 text-sm">
              <p>Welcome to Doctor World Consultancy. By accessing our website, you agree to be bound by these Terms and Conditions.</p>
              <h4 className="font-semibold text-base mt-2">1. Services</h4>
              <p>We provide educational consultancy services, assisting Indian students in securing admissions to medical universities abroad.</p>
              <h4 className="font-semibold text-base mt-2">2. Accuracy of Information</h4>
              <p>While we strive to ensure that all information on our website is accurate and up-to-date, we cannot guarantee its absolute correctness. University details and requirements are subject to change.</p>
              <h4 className="font-semibold text-base mt-2">3. User Responsibilities</h4>
              <p>Users must provide accurate information when filling out applications or contacting us.</p>
              <h4 className="font-semibold text-base mt-2">4. Contact</h4>
              <p>If you have any questions, please contact us at doctorworldconsultancy@gmail.com.</p>
            </div>
            <div className="mt-6 text-right">
              <button onClick={() => setShowTerms(false)} className={`px-4 py-2 rounded-xl text-white font-medium bg-blue-600 hover:bg-blue-700 transition-colors`}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Privacy Policy Modal */}
      {showPrivacy && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setShowPrivacy(false)}></div>
          <div className={`relative w-full max-w-2xl rounded-2xl shadow-xl p-6 ${darkMode ? 'bg-gray-800 text-gray-300 border border-gray-700' : 'bg-white text-gray-700'} max-h-[80vh] flex flex-col`}>
            <div className="flex justify-between items-center mb-4">
              <h2 className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>Privacy Policy</h2>
              <button 
                onClick={() => setShowPrivacy(false)}
                className={`p-2 rounded-full ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'}`}
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
              </button>
            </div>
            <div className="overflow-y-auto pr-2 space-y-4 text-sm">
              <p>Your privacy is important to us. This policy outlines how we handle the personal information we collect.</p>
              <h4 className="font-semibold text-base mt-2">1. Information Collection</h4>
              <p>We may log information such as your name, email, phone number, and academic details when you use our forms and services.</p>
              <h4 className="font-semibold text-base mt-2">2. Use of Information</h4>
              <p>The information collected is used exclusively to assist you with medical admissions abroad, counseling, and related activities.</p>
              <h4 className="font-semibold text-base mt-2">3. Data Protection</h4>
              <p>We implement security measures to protect your personal details. We do not sell or share your data with unauthorized third parties.</p>
            </div>
            <div className="mt-6 text-right">
              <button onClick={() => setShowPrivacy(false)} className={`px-4 py-2 rounded-xl text-white font-medium bg-blue-600 hover:bg-blue-700 transition-colors`}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
